angular
	.module 'App.Module.Role', []
	.config ($stateProvider, DEFAULT_RESOLVE_POLICY) ->
		$stateProvider
			.state 'roles',
				url: '/roles',
				views:
					main:
						templateUrl: '@app/layout/views/app.entity-administration.view.html'
						controller: 'MainCrudController'
						controllerAs: 'mainCrud'

					'entity_search@roles':
						templateUrl: '@app/layout/views/app.entity-search.view.html'
						controller: 'BaseSearchController'
						controllerAs: 'search'
				resolvePolicy: DEFAULT_RESOLVE_POLICY
				resolve:
					rights: (RightRepository) ->
						return RightRepository.getEntities()
					models: (DataRightRepository) ->
						return DataRightRepository.getModelMap()
				data:
					restrict: "Backoffice.TopMenu.Users.Roles"
					searchParams:
						repositoryName: 'UserRoleRepository'
						title: 'general.roles'
						filterEnabled: ->
							return @ConfigurationService.isEnabled 'Backoffice.RoleManagement.EnableRoleSearch'
						createEnabled: ->
							return @ConfigurationService.isEnabled 'Backoffice.RoleManagement.EnableRoleCreation'

			.state 'roles.edit',
					url: '/:id'
					views:
						entity_view:
							templateUrl: '@app/layout/views/app.entity-container.view.html'
					resolvePolicy: DEFAULT_RESOLVE_POLICY
					resolve:
						ConfigurationList: (ConfigurationRepository, $stateParams) ->
							if !_.isEmpty($stateParams.id)
								return ConfigurationRepository.listRoleConfigurations $stateParams.id
							return []
						role: (UserRoleRepository, $stateParams) ->
							return UserRoleRepository.getEntity $stateParams.id

			.state 'roles.edit.details',
					url: '/edit',
					views:
						entity_sub_view:
							controller: 'RoleController'
							controllerAs: 'vm'
							templateUrl: '@app/role/role.view.html'
